import request from '@http';
// 问卷设计列表
export function getFeedbackListApi(params) {
    return request({
        method: "GET",
        url: "api/gzf/feedback/page",
        params,
    });
}

// 添加问卷/模块/题目
export function addFeedbackApi(data) {
    return request({
        method: "PUT",
        url: "api/gzf/feedback/save",
        data,
    });
}
// 问卷详情
export function detailFeedbackApi(params) {
    return request({
        method: 'GET',
        url: "api/gzf/feedback/detail",   
        params,
    });
}
// 问卷回显
export function detailLeasorFeedbackApi(params) {
    return request({
        method: 'GET',
        // url: "api/gzf/feedback/detail",
        url: "api/gzf/feedback/leasor/detail",  
        params,
    });
}
// 修改问卷/模块/题目
export function updateFeedbackApi(data) {
    return request({
        method: "PUT",
        url: "api/gzf/feedback/update",
        data,
    });
}

//问卷收集列表
export function LeasorFeedbackListGET(params) {
    return request({
        method: 'GET',
        url: 'api/gzf/feedback/leasor/page',
        params,
    });
}
